export enum RefillUnitType {
  PIECES = "pieces",
  MULTIPACK = "multipack",
  PALLET = "pallet",
}
